import { sanitizeWithRules } from './format-converters.js';
/* *
 * * MAIN EXPORT
 * */

var applyRulesToHtml = function applyRulesToHtml(htmlString) {
  var sanitizedHtmlString = sanitizeWithRules(htmlString);
  var tempDiv = document.createElement('div');
  tempDiv.innerHTML = sanitizedHtmlString; // apply rules by manipulating the html content of tempDiv.innerHTML wrapUnwrappedElements(tempDiv);

  removeRedundantLineBreaks(tempDiv);
  removeEmptyParagraphs(tempDiv);
  addSpaceToEmptyElements(tempDiv);
  return tempDiv.innerHTML;
};

var addSpaceToEmptyElements = function addSpaceToEmptyElements(root) {
  var allElements = root.getElementsByTagName('*');

  for (var i = 0; i < allElements.length; i++) {
    var element = allElements[i]; // Check for empty elements with opening and closing tags

    if (element.innerHTML.trim() === '') {
      element.innerHTML = ' ';
    } // Check for self-closing tags


    if (element.outerHTML.match(/\/>/)) {
      var _element$parentNode;

      var tagName = element.tagName.toLowerCase();
      var newElement = document.createElement(tagName);
      newElement.innerHTML = ' ';
      (_element$parentNode = element.parentNode) === null || _element$parentNode === void 0 || _element$parentNode.replaceChild(newElement, element);
    }
  }
};

var removeRedundantLineBreaks = function removeRedundantLineBreaks(root) {
  var paragraphs = root.querySelectorAll('p');
  paragraphs.forEach(function (p) {
    if (p.previousSibling && p.previousSibling.nodeName === 'BR') {
      p.previousSibling.remove();
    }
  });
};

var removeEmptyParagraphs = function removeEmptyParagraphs(root) {
  var emptyParagraphs = root.querySelectorAll('p:empty');
  emptyParagraphs.forEach(function (p) {
    return p.remove();
  });
};

export { applyRulesToHtml };